/** The page that shows one source document by its attachment id; the Assignment Center opens it in a new tab. */
export const SOURCE_DOCUMENT_ROUTE = "/source-document/$attachmentId" as const;

/** The address of the source document page of one attachment. */
export const sourceDocumentPath = (attachmentId: number): string => `/source-document/${attachmentId}`;
